<template>
  <div tabindex="-1">
    <input type="hidden" :value="jsonItems" name="supplier_invoice_items">

    <div class="portlet light portlet-fit invoice-details-portlet" @keydown="downKeyAdd">
      <div class="portlet-title" v-if="!formMode">
        <div class="caption">
          <i class="fa fa-list"></i>
          <span class="caption-subject bold uppercase">Pièces</span>
        </div>
        <div class="tools">
          <a href="javascript:;" class="collapse" data-original-title="" title='Afficher / Cacher'> </a>
        </div>
      </div>
      <div class="portlet-body">
        <div v-if="loading">
          <div class="text-center">
            <span style="font-size: 22px"><i class="fa fa-refresh fa-spin"></i></span>
          </div>
        </div>
        <div v-else>
          <table id="invoice-details-table" class="table table-bordered" style="margin-bottom: 5px">
            <thead>
              <tr>
                <th v-if="!readOnly">&nbsp;</th>
                <th v-if="!readOnly">&nbsp;</th>
                <th>Pièce</th>
                <th>Description</th>
                <th class="width-min-nowrap">Quantité</th>
                <th class="width-min-nowrap text-right">Prix unitaire</th>
                <th class="width-min-nowrap text-right">Sous-Total</th>
                <th class="width-min-nowrap text-right">T.V. Pneu</th>
                <th class="width-min-nowrap text-right">Total</th>
              </tr>
            </thead>
            <draggable v-model="items" tag="tbody" handle=".draggable-handle" @update="handleChange">
              <tr v-for="(item, index) in items" v-bind:key="index" class="item-row">
                <td class="width-min-nowrap draggable-handle" v-if="!readOnly" style="padding: 3px 8px; vertical-align: middle; font-size: 22px; cursor:move">
                  <i v-if="item.part_index === undefined" class="fa fa-bars"></i>
                </td>
                <td class="width-min-nowrap text-center" v-if="!readOnly" style="padding: 8px">
                  <a class="btn btn-circle btn-icon-only btn-default tooltips mr-0" @click="removeItem(index)" data-container="body" data-placement="top" data-original-title='Supprimer' href="javascript:;" title="Supprimer">
                    <i class="icon-trash"></i>
                  </a>
                </td>
                <td class="input" style="width: 350px; min-width: 350px;">
                  <div v-if="!readOnly">
                    <input type="hidden" v-model="item.supplier_invoice_item_invoice_id">
                    <input type="hidden" v-model="item.supplier_invoice_item_service_id">

                    <select-two-items
                      :endpoint="partsEndpoint" 
                      :type="item.type" 
                      v-model="item.supplier_invoice_item_item" 
                      @selected="onSelect(index, $event);"
                      @clear="onClear(index)" 
                      @onCancel="deleteItemCancel(index)"
                      :ref="`select2-part-${index}`"
                      :initial-value="(item.supplier_invoice_item_item.id)?item.supplier_invoice_item_item.id.toString():''" 
                      :initial-display="item.supplier_invoice_item_item.text"
                      :part-number-first="true"
                      :add-form-base-end-point="baseEndpoint+'part/add'"
                      :add-form-title="'Ajout d\'une pièce'"
                      :add-form-selector="'#form_part'"
                      :add-text-input-selector="'#part_name'"
                      :edit-form-base-end-point="baseEndpoint+'part/edit'"
                      :edit-form-title="'Modifier une pièce'"
                      :edit-form-selector="'#form_part'"
                      :edit-text-input-selector="'#part_name'"
                      :allow-add="allowAddParts"
                      :allow-edit="allowEditParts"
                      :dropdownParent="formMode ? '.modal-supplier_invoice' : 'body'" 
                    />

                  </div>
                  <div v-else style="padding: 5px;">
                    {{item.supplier_invoice_item_item.text}}
                  </div>
                </td>
                <td class="input">
                  <div v-if="!readOnly">
                    <textarea ref="description-box" class="form-control" style="width:100%; min-height: 35px; resize: vertical" v-model="item.supplier_invoice_item_description" @change="handleChange" @input="autoResize"></textarea>
                  </div>
                  <div v-else style="padding: 5px;" v-html="item.supplier_invoice_item_description.replace(/\n/g, '<br>')"></div>
                </td>
                <td class="width-min-nowrap input" style="width: 100px">
                  <div>
                    <div v-if="!readOnly">
                      <input style="width: 100px" onFocus="this.select()" id="qty" ref="qty" class="form-control supplier_invoice_item_qty select-on-focus" type="number" v-model="item.supplier_invoice_item_qty" @change="handleChange">
                    </div>
                    <div v-else style="padding: 5px; text-align: right;">
                      {{item.supplier_invoice_item_qty}}
                    </div>
                  </div>
                  <div>
                    Inventaire: <span :class="itemInventoryCount(item) < 0 ? 'font-red' : 'font-black'">{{itemInventoryCount(item)}}</span>
                    RT: <span :class="itemReturnCount(item) < 0 ? 'font-red' : 'font-black'">{{itemReturnCount(item)}}</span>
                  </div>
                </td>
                <td class="width-min-nowrap input" style="width: 100px; position: relative">
                  <div>
                    <div v-if="!readOnly" style="position: relative">
                      <span style="position: absolute; top: 6px; right: 8px; font-size: 16px; user-select: none">$</span>
                      <input style="width: 100px; padding-right: 20px" onFocus="this.select()" class="form-control supplier_invoice_item_price text-right select-on-focus" type="text" v-model="item.supplier_invoice_item_price" @change="handleChange">
                    </div>
                    <div v-else style="padding: 5px; text-align: right;">
                      {{item.supplier_invoice_item_price}} $
                    </div>
                  </div>
                </td>
                <td class="width-min-nowrap text-right" style="min-width: 100px;">
                  <div>{{itemSubTotal(item)}} $</div>
                </td>
                <td class="width-min-nowrap input" style="width: 100px; position: relative">
                  <div v-if="!readOnly">
                    <span style="position: absolute; top: 8px; right: 8px; font-size: 16px; user-select: none">$</span>
                    <input onFocus="this.select()" style="width: 100px; padding-right: 20px" class="form-control supplier_invoice_item_tire_tax text-right select-on-focus" type="text" v-model="item.supplier_invoice_item_tire_tax" @change="handleChange">
                  </div>
                  <div v-else style="padding: 5px; text-align: right;">
                    {{item.supplier_invoice_item_tire_tax}} $
                  </div>
                </td>
                <td class="width-min-nowrap text-right" style="min-width: 100px;">
                  <div>{{itemTotal(item)}} $</div>
                </td>
              </tr>
            </draggable>
            <tfoot style="border: none">
              <tr style="border: none">
                <td colspan="6" style="border: none">
                  <button v-if="!readOnly" class="btn purple" @click="addItem" tabindex="3"><i class="fa fa-plus"></i> Ajouter une pièce</button>
                </td>
                <td colspan="5" style="border: none; padding-right: 0; padding-bottom: 0">
                  <div style="float: right;">
                    <table class="table-bordered text-right">
                      <tr>
                        <td style="padding: 5px;">Total sans taxes:</td>
                        <td style="padding: 5px;">{{round(subtotal,2)}} $</td>
                      </tr>
                      <tr>
                        <td style="padding: 5px;">Montant taxable TPS:</td>
                        <td style="padding: 5px;">{{round(taxableTpsAmount,2)}} $</td>
                      </tr>
                      <tr>
                        <td style="padding: 5px;">TPS ({{tpsValue}} %):</td>
                        <td style="padding: 5px;">{{round(tpsAmount,2)}} $</td>
                      </tr>
                      <tr>
                        <td style="padding: 5px;">Montant taxable TVQ:</td>
                        <td style="padding: 5px;">{{round(taxableTvqAmount,2)}} $</td>
                      </tr>
                      <tr>
                        <td style="padding: 5px;">TVQ ({{tvqValue}} %):</td>
                        <td style="padding: 5px;">{{round(tvqAmount,2)}} $</td>
                      </tr>
                      <tr>
                        <td style="padding: 5px;">T.V. Pneu:</td>
                        <td style="padding: 5px; min-width: 100px;">{{round(tireTotal,2)}} $</td>
                      </tr>
                      <tr>
                        <td style="padding: 5px; font-weight: bold;">Total:</td>
                        <td style="padding: 5px; min-width: 100px; font-weight: bold;">{{round(grandTotal,2)}} $</td>
                      </tr>
                    </table>
                  </div>
                </td>
              </tr>
            </tfoot>

          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable';

export default {
  name: "supplier-invoice-item-list",
  components: {
    draggable,
  },
  props: {
    supplierInvoiceId: {
      type: String,
      required: true
    },
    baseEndpoint: {
      type: String,
      required: true
    },
    tpsValue: {
      type: Number,
      required: true
    },
    tvqValue: {
      type: Number,
      required: true
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    allowEditParts: {
      type: Boolean,
      default: true
    },
    allowAddParts: {
      type: Boolean,
      default: true
    },
    formMode: {
      type: Boolean,
      default: false
    },
    autoAddSupplierParts: {
      type: Boolean,
      default: false
    },
    defaultHourRate: {
      type: String,
      default: "0.00"
    }
  },
  data(){
    return {
      loading: true,
      items: [],
      updateCounter: 0
    }
  },
  async mounted(){
    this.loading = true;
    await this.loadItems();
    const supplierSelect = $('#supplier_invoice_supplier_id, #supplier_invoice_view_supplier_id');
    supplierSelect.off('.supplierInvoiceParts').on('select2:select.supplierInvoiceParts', (event) => {
      if ((this.formMode && parseInt(this.supplierInvoiceId) === 0) || this.autoAddSupplierParts) {
        this.addPartsWithoutNumberForSupplier(event.params.data.id);
      }
    });
    $(".supplier-invoice-items-portlet").on("focus", "input.select-on-focus", function() {
      $(this).trigger("select");
    })
    window._vue_supplier_invoice_item_list = this;
    setTimeout(() => {
      this.autoResize();
    }, 500);
  },
  beforeDestroy(){
    $('#supplier_invoice_supplier_id, #supplier_invoice_view_supplier_id').off('.supplierInvoiceParts');
  },
  computed:{
    jsonItems(){
      this.updateCounter;
      return JSON.stringify(this.items);
    },
    partsEndpoint(){
      this.updateCounter;
      return `${this.baseEndpoint}supplier_invoice/select2/parts`;
    },
    itemSubTotal() {
      return (item) => {
        return this.round(item.supplier_invoice_item_price * item.supplier_invoice_item_qty, 2)
      }
    },
    itemTotal() {
      return (item) => {
        let subtotal = parseFloat(this.itemSubTotal(item));

        let tps = 0;
        if(item.supplier_invoice_item_taxable_tps){
          tps = subtotal * this.tpsValue / 100;
        }
        tps = Math.round(tps * 100) / 100;

        let tvq = 0;
        if(item.supplier_invoice_item_taxable_tvq){
          tvq = subtotal * this.tvqValue / 100;
        }
        tvq = Math.round(tvq * 100) / 100;

        let total = subtotal + tps + tvq;
        if(item.supplier_invoice_item_tire_tax != null){
          total += parseFloat(item.supplier_invoice_item_tire_tax) * parseFloat(item.supplier_invoice_item_qty)
        }

        return this.round(total, 2);
      }
    },
    subtotal(){
      this.updateCounter;
      var value = 0;
      for (const itm of this.items) {
        value += parseFloat(itm.supplier_invoice_item_price) * parseFloat(itm.supplier_invoice_item_qty);
      }
      return value;
    },
    taxableTpsAmount(){
      this.updateCounter;
      var value = 0;

      for (const itm of this.items) {
        if(itm.supplier_invoice_item_taxable_tps){
          value += parseFloat(this.itemSubTotal(itm))
        }
      }

      return value;
    },
    tpsAmount(){
      var value = parseFloat(this.taxableTpsAmount) * (this.tpsValue/100);
      return this.round(value, 2);
    },
    taxableTvqAmount(){
      this.updateCounter;

      var value = 0;
      for (const itm of this.items) {
        if(itm.supplier_invoice_item_taxable_tvq){
          value += parseFloat(this.itemSubTotal(itm))
        }
      }

      return value;
    },
    tvqAmount(){
      this.updateCounter;
      var value = parseFloat(this.taxableTvqAmount) * this.tvqValue / 100;
      return this.round(value, 2);
    },
    tireTotal() {
      this.updateCounter;
      let total = 0;
      for (const part of this.items) {
        if(part.supplier_invoice_item_tire_tax != null){
          total += parseFloat(part.supplier_invoice_item_tire_tax) * parseFloat(part.supplier_invoice_item_qty);
        }
      }
      return total;
    },
    grandTotal(){
      this.updateCounter;
      var value = parseFloat(this.subtotal) + parseFloat(this.tpsAmount) + parseFloat(this.tvqAmount)/* + parseFloat(this.tireTotal)*/;
      return this.round(value, 2);
    },
    itemInventoryCount() {
      this.updateCounter;
      return (item) => {
        let qtyUsed = 0;
        for (const subitem of this.items) {
          if(subitem.supplier_invoice_item_part_id == item.supplier_invoice_item_part_id) {
            qtyUsed += parseInt(subitem.supplier_invoice_item_qty);
          }
        }

        return parseFloat(item.part_inventory) + qtyUsed;
      }
    },
    itemReturnCount() {
      this.updateCounter;
      return (item) => {
        return Math.round(parseFloat(item.part_return)*100)/100;
      }
    }
  },
  methods:{
    deleteItemCancel(index)
    {
      this.items.splice(index,1)
    },
    focus (index) {
      this.$nextTick(() => {
        this.$refs.qty[index].focus()
        //console.log(index)
        //console.log(this.$refs.qty)
      }) 
    },
    async loadItems() {
      this.loading = true;

      if(parseInt(this.invoiceId) == 0){
        this.loading = false;
        return;
      }

      let data = await $.get(`${this.baseEndpoint}supplier_invoice/view/${this.supplierInvoiceId}/items`);

      this.loading = false;
      
      let partQty = {};

      for (const res of data) {
        res.supplier_invoice_item_taxable_tps = res.supplier_invoice_item_taxable_tps == "1";
        res.supplier_invoice_item_taxable_tvq = res.supplier_invoice_item_taxable_tvq == "1";
        res.part_inventory = parseFloat(res.part_inventory);
        res.part_return = parseFloat(res.part_return);
        res.expanded = true;
        
        if(partQty[res.supplier_invoice_item_part_id] === undefined){
          partQty[res.supplier_invoice_item_part_id] = 0;
        }
        partQty[res.supplier_invoice_item_part_id] += parseFloat(res.supplier_invoice_item_qty)
        
        if(res.supplier_invoice_item_part_id != 0){
          res.supplier_invoice_item_item = {
            id: res.supplier_invoice_item_part_id,
            text: this.partDisplayText(res.part_number, res.part_name),
            type: "part"
          };
        }
        else{
          res.supplier_invoice_item_item = { id: null, text: "" };
        }
      }

      for (const part of data) {
        part.part_inventory -= partQty[part.supplier_invoice_item_part_id] ?? 0;
      }
      
      this.items = data;
    },
    autoResize() {
      if(this.$refs["description-box"] !== undefined){
        for (const textarea of this.$refs["description-box"]) {
          textarea.style.height = "10px";
          textarea.style.height = `${textarea.scrollHeight+2}px`;
        }
      }
    },
    round(number, precision) {
      return (parseFloat(number) + 0.00000001).toFixed(2);
    },
    partDisplayText(partNumber, partName) {
      const number = String(partNumber || '').trim() || '*vide*';
      return `${number} - ${partName || ''}`;
    },
    addPartsWithoutNumberForSupplier(supplierId) {
      $.get(`${this.baseEndpoint}supplier_invoice/parts-without-number/${supplierId}`)
        .done((parts) => {
          if (!parts.length) {
            toastr.info("Aucune pièce sans numéro n’est associée à ce fournisseur.");
            return;
          }

          const addParts = (overwrite) => {
            const newItems = parts.map((part, index) => ({
              supplier_invoice_item_id: null,
              supplier_invoice_item_item: {
                id: part.id,
                text: this.partDisplayText(part.part_number, part.part_name),
                type: "part",
                label: part.part_number,
                name: part.part_name
              },
              supplier_invoice_item_part_id: part.id,
              supplier_invoice_item_supplier_invoice_id: this.supplierInvoiceId,
              supplier_invoice_item_description: `${part.part_name || ''}\nScan: ${part.part_scan || ''}`,
              supplier_invoice_item_price: part.part_cost_price || "0.00",
              supplier_invoice_item_qty: "1.00",
              supplier_invoice_item_tire_tax: part.tire_tax || 0,
              supplier_invoice_item_taxable_tps: true,
              supplier_invoice_item_taxable_tvq: true,
              supplier_invoice_item_order: index,
              part_inventory: parseFloat(part.part_inventory || 0),
              part_return: parseFloat(part.part_return || 0)
            }));

            if (overwrite) {
              this.items = newItems;
            } else {
              const nextOrder = this.items.length
                ? Math.max(...this.items.map((item) => parseInt(item.supplier_invoice_item_order || 0))) + 1
                : 0;
              newItems.forEach((item, index) => {
                item.supplier_invoice_item_order = nextOrder + index;
              });
              this.items.push(...newItems);
            }
            this.updateCounter++;
            this.saveItems();
          };

          if (!this.items.length) {
            addParts(false);
            return;
          }

          bootbox.dialog({
            title: "Pièces sans numéro",
            message: "La grille contient déjà des éléments. Voulez-vous ajouter ces pièces, écraser la grille ou ne rien ajouter?",
            buttons: {
              add: {
                label: "Ajouter",
                className: "btn-primary",
                callback: () => addParts(false)
              },
              overwrite: {
                label: "Écraser",
                className: "btn-danger",
                callback: () => addParts(true)
              },
              cancel: {
                label: "Ne pas ajouter",
                className: "btn-default",
                callback: () => {}
              }
            }
          });
        })
        .fail((jqXHR, textStatus, thrownErr) => {
          processXHRError(jqXHR, textStatus, thrownErr);
          console.error("Could not load supplier parts without a number:", textStatus);
        });
    },
    saveItems() { 
      if(this.formMode) return;
      var message_text = "<h1>Enregistrement...<br>Veuillez patienter</h1>";
      $.post(`${this.baseEndpoint}supplier_invoice/view/${this.supplierInvoiceId}/items/save`, {data: this.items})
    },
    downKeyAdd(ev) {
      if(ev.keyCode == '40'){
        ev.preventDefault();
        this.addItem();
      }
    },
    addItem() {
      var index = 0;
      if(this.items[this.items.length-1] !== undefined){
        index = parseInt(this.items[this.items.length-1].supplier_invoice_item_order) + 1;
      }

      this.items.push({
        new: "NEWWWWW",
        supplier_invoice_item_id: null,
        supplier_invoice_item_item: { id: null, text: "", type: null },
        supplier_invoice_item_part_id: null,
        supplier_invoice_item_supplier_invoice_id: this.supplierInvoiceId,
        supplier_invoice_item_description: "",
        supplier_invoice_item_price: "0.00",
        supplier_invoice_item_qty: "1.00",
        supplier_invoice_item_taxable_tps: true,
        supplier_invoice_item_taxable_tvq: true,
        supplier_invoice_item_order: index
      })

      setTimeout(() => {
        var count = this.items.length-1;
        this.$refs["select2-part-"+index][this.$refs["select2-part-"+index].length-1].addItem();
        //console.log(this.$refs.qty[0])
        //this.$nextTick(() =>this.$refs.qty[0].focus())
      }, 50)
      
    },
    addItem() {
      var index = 0;
      if(this.items[this.items.length-1] !== undefined){
        index = parseInt(this.items[this.items.length-1].supplier_invoice_item_order) + 1;
      }

      this.items.push({
        new: "NEWWWWW",
        supplier_invoice_item_id: null,
        supplier_invoice_item_item: { id: null, text: "", type: null },
        supplier_invoice_item_part_id: null,
        supplier_invoice_item_supplier_invoice_id: this.supplierInvoiceId,
        supplier_invoice_item_description: "",
        supplier_invoice_item_price: "0.00",
        supplier_invoice_item_qty: "1.00",
        supplier_invoice_item_taxable_tps: true,
        supplier_invoice_item_taxable_tvq: true,
        supplier_invoice_item_order: index
      })

      setTimeout(() => {
        var count = this.items.length-1;
        if (this.$refs["select2-part-"+index])
          this.$refs["select2-part-"+index][this.$refs["select2-part-"+index].length-1].addItem();
        //console.log(this.$refs.qty[0])
        //this.$nextTick(() =>this.$refs.qty[0].focus())
      }, 50)
      
    },
    addItemCore(index, coreItem) {
      //check if item already exists
      let search = this.items.find(x => x.supplier_invoice_item_part_id === coreItem.part_id);
      if (search && search.supplier_invoice_item_part_id > 0){
        return;
      }

      if(this.items[this.items.length-1] !== undefined){
        index = parseInt(this.items[this.items.length-1].supplier_invoice_item_order) + 1; //todo move items I guess if the core-of item is not at the end of list
      }

      this.items.push({
        new: "NEWWWWW",
        supplier_invoice_item_id: null,
        supplier_invoice_item_item: { id: coreItem.part_id, text: coreItem.part_number, type: null },
        supplier_invoice_item_part_id: coreItem.part_id,
        supplier_invoice_item_supplier_invoice_id: this.supplierInvoiceId,
        supplier_invoice_item_description: coreItem.part_name + "\nScan: " + coreItem.part_scan,
        supplier_invoice_item_price: coreItem.part_cost_price,
        supplier_invoice_item_qty: "1.00",
        supplier_invoice_item_tire_tax: coreItem.tire_tax,
        supplier_invoice_item_taxable_tps: true,
        supplier_invoice_item_taxable_tvq: true,
        part_inventory: coreItem.part_inventory,
        part_return: coreItem.part_return,
        supplier_invoice_item_order: index
      });
    },
    removeItem: function(index){
      bootbox.dialog({
        title: "Supprimer un item",
        message: "Êtes-vous sûr de supprimer cet item?",
        buttons: {				
          remove: {
            label: L('YES_WORD'),
            className: "btn-danger",
            callback: () => {
              this.items.splice(index, 1);
              this.saveItems();
            }
          },					
          cancel: {
            label: L("CANCEL"),
            className: "btn",
            callback: () => {}
          }
        }
      })
    },
    fixPrice(item) {
      item.supplier_invoice_item_price = item.supplier_invoice_item_price.replace(/[^\d.-]/g,'');
      if(item.supplier_invoice_item_price == "") item.supplier_invoice_item_price = 0;
      item.supplier_invoice_item_price = parseFloat(item.supplier_invoice_item_price).toFixed(2);
    },
    onSelect(index, item) {
      var split = item.id.toString().split("-");
      var id = item.itemId || item.item_id || split[1];
      this.updateCounter++;
      
      for (const part of this.items) {
        if(part.supplier_invoice_item_part_id == id && part != item) {
          item.part_inventory = part.part_inventory;
          item.part_return = part.part_return;
          break;
        }
      }
      this.$set(this.items[index], "supplier_invoice_item_part_id", id);
      this.$set(item, "text", this.partDisplayText(item.label || item.part_number, item.name || item.part_name));
      this.$set(this.items[index], "supplier_invoice_item_description", item.name + "\nScan: " + item.scan);
      this.$set(this.items[index], "supplier_invoice_item_price", item.part_cost_price);
      this.$set(this.items[index], "supplier_invoice_item_tire_tax", item.tire_tax);
      this.$set(this.items[index], "part_inventory", item.part_inventory);
      this.$set(this.items[index], "part_return", item.part_return);

      
      if (typeof item.part_core != "undefined" && typeof item.part_core_part_item != "undefined") {
        this.addItemCore(index+1,item.part_core_part_item);
      }
      this.saveItems();

      this.focus(index); 
    },
    onClear(index) {
      this.updateCounter++;
      this.items[index].supplier_invoice_item_part_id = null;
    },
    checkboxOrderStatusChange(item, value, event){
      item.supplier_invoice_item_parts_status = (item.supplier_invoice_item_parts_status == value) ? 0 : value;
      this.handleChange();
    },
    handleChange() {
      let i = 0;
      for (const item of this.items) {
        item.supplier_invoice_item_order = i++;
      }
      this.saveItems();
    },
  }
}

</script>

<style lang="scss" scoped>
.invoice-details-portlet{
  td.input{
    padding: 2px !important;
  }

  td.cb{
    text-align: center;
  }

  td.cb input{
    width: 18px;
    height: 18px;
  }

  td.cb .supplier_invoice_item_parts_status_div{
    vertical-align: top;
  }

  td.cb input.supplier_invoice_item_parts_status{
    width: 14px;
    height: 14px;
    margin-top: 0;
    vertical-align: middle;
  }

  .width-min-nowrap{
    width: 1%;
    white-space: nowrap;
  }
  
  .item-row:hover{
    background-color: rgb(204, 232, 255) !important;
  }

  .item-row {
    background-color: #fff;
  }

}
</style>